import { getModuleTitle } from '../openingUtils';
import { getKeepsakeShareInfo } from './keepsakeShareService';
import { getRevealRegistryMeta, resolveRevealStyle } from './revealRegistry';
import {
  firstTextValue,
  getBlessingState,
  getFrameGalleryState,
  getMapState,
  getMuseumState,
  getOpenWhenLetters,
  getPhotoState,
  getPolaroidState,
  getThenNowState,
  getTimelineState,
  getVoiceState,
} from './revealStateSelectors';

export const TEXTURE_OPTIONS = [
  'none',
  'paper',
  'map',
  'archive',
  'linen',
  'vellum',
  'film',
  'champagne',
  'botanical',
];

const normalizeTexture = (value = 'none') => {
  const normalized = String(value || 'none')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_');
  return TEXTURE_OPTIONS.includes(normalized) ? normalized : 'none';
};

export const getRevealMeta = (module, index, context = {}) => {
  const baseMeta = getRevealRegistryMeta(module?.type);
  const revealStyle = resolveRevealStyle(
    baseMeta,
    firstTextValue(module?.data?.revealStyle, module?.data?.reveal_style, module?.data?.openingStyle),
  );
  const texture = normalizeTexture(firstTextValue(module?.data?.texture, module?.data?.revealTexture, baseMeta.texture));
  const moduleTitle = getModuleTitle(module, index);
  const openWhenLetters = getOpenWhenLetters(module);
  const displayTitle = firstTextValue(
    module?.data?.title,
    module?.data?.label,
    module?.data?.prompt,
    moduleTitle,
  );
  const recipientName = firstTextValue(
    module?.data?.recipientName,
    module?.data?.toName,
    context.recipientName,
    'Someone special',
  );
  const shareInfo = getKeepsakeShareInfo({
    pageId: context.pageId,
    explicitUrl: firstTextValue(module?.data?.shareUrl, module?.data?.shortLinkUrl, module?.data?.url, context.shareUrl),
    explicitLabel: firstTextValue(
      module?.data?.shortLink,
      module?.data?.shareLabel,
      module?.data?.shortLinkLabel,
      context.shortLinkLabel,
    ),
  });
  const shortLinkLabel = firstTextValue(
    module?.data?.shortLink,
    module?.data?.shareLabel,
    shareInfo.shortLinkLabel,
  );

  return {
    ...baseMeta,
    moduleTitle,
    displayTitle,
    recipientName,
    shareUrl: shareInfo.shareUrl,
    shortLinkLabel,
    texture,
    revealStyle,
    supportedRevealStyles: baseMeta.revealStyles || [],
    isFinalLayer: Boolean(context.isFinalLayer),
    letterCount: openWhenLetters.length,
    letterStack: openWhenLetters
      .slice(0, 4)
      .map((letter, letterIndex) => firstTextValue(letter.title, letter.label, letter.prompt, `Note ${letterIndex + 1}`)),
    voiceState: getVoiceState(module),
    photoState: getPhotoState(module),
    thenNowState: getThenNowState(module),
    frameGalleryState: getFrameGalleryState(module),
    timelineState: getTimelineState(module),
    mapState: getMapState(module, { ...context, revealStyle }),
    museumState: getMuseumState(module, { ...context, revealStyle }),
    blessingState: getBlessingState(module, { ...context, revealStyle }),
    polaroidState: getPolaroidState(module),
  };
};
